module.exports = __webpack_public_path__ + "static/engagement_banner_icon@3x.b4d3a8bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/engagement/engagement_banner_icon@3x.png
// module id = 657
// module chunks = 193162123475590